// Store to saved some filters accross navigation:
// - gateways
// - end-devices
// - multicast groups
const state = {
  gatewaysFilters: {},
  endDevicesFilters: {},
  multicastGroupsFilters: {}
}

export const getters = {
  gatewaysFilters: state => state.gatewaysFilters,
  endDevicesFilters: state => state.endDevicesFilters,
  multicastGroupsFilters: state => state.multicastGroupsFilters
}

export const mutations = {
  setGatewaysFilters (state, filters) {
    state.gatewaysFilters = filters
  },
  resetGatewaysFilters (state) {
    state.gatewaysFilters = {}
  },

  setEndDevicesFilters (state, filters) {
    state.endDevicesFilters = filters
  },
  resetEndDevicesFilters (state) {
    state.endDevicesFilters = {}
  },

  setMulticastGroupsFilters (state, filters) {
    state.multicastGroupsFilters = filters
  },
  resetMulticastGroupsFilters (state) {
    state.multicastGroupsFilters = {}
  }
}

export default {
  state,
  getters,
  mutations
}
